import { useGetFeaturedPropertiesQuery } from '@apis/middlewareTokkoApi/properties'
import { excludeIncludeDevelopments, getFeatured } from '@helpers/helper.developments'
import { ElementHTML } from '@helpers/helper.rendering'
import useQueryDevelopments from '@hooks/useQueryDevelopments'
import useQueryProperties from '@hooks/useQueryProperties'
import { Link } from 'gatsby'
import React, { useEffect, useRef, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Development, DevelopmentMediacore, Property, RealEstateDataPageComponentData } from 'types'

const Summary_Props_3 = (props: RealEstateDataPageComponentData) => {
  const {
    global_data,
    title,
    titleElement,
    titleColor,
    backgroundColor,
    button,
    columns,
    isDevelopment,
    excludeTag,
    includeTag,
  } = props
  const tokkoKey = global_data.pageConfig.keys.tokko
  const middlewarev2: boolean = process.env.GATSBY_USE_MIDDLEWARE_V2?.toLowerCase() === 'true'
  const icons: string = global_data.pageConfig.design.icons
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const [isMounted, setIsMounted] = useState(false)

  const { data: featuredPropertiesData, isLoading: isLoadingProperties } = tokkoKey
    ? middlewarev2
      ? useQueryProperties({
          filters: {
            location: [],
            type: [],
            operation: '',
            environments: '',
            bedrooms: '',
            is_starred_on_web: true,
            age: '',
            address: '',
            producer_id: '',
            price: {},
            environments_types: [],
            generals: [],
            services: [],
            specials: [],
          },
          tokkoKey,
        })
      : useGetFeaturedPropertiesQuery({ API_KEY: tokkoKey })
    : useQueryProperties({
        filters: {
          location: [],
          type: [],
          operation: '',
          environments: '',
          is_starred_on_web: true,
          bedrooms: '',
          age: '',
          address: '',
          producer_id: '',
          price: {},
          environments_types: [],
          generals: [],
          services: [],
          specials: [],
        },
        tokkoKey,
      })

  const { data: allDevelopmentsData, isLoading: isLoadingDevs } = isDevelopment
    ? useQueryDevelopments(tokkoKey)
    : { data: null, isLoading: false }

  const noFeaturedProperties =
    !isLoadingProperties &&
    (!featuredPropertiesData?.objects?.length || featuredPropertiesData === undefined)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const scrollRowRef = useRef<HTMLDivElement>(null)

  const handleScroll = (direction: number) => {
    if (scrollRowRef.current) {
      const scrollAmount = scrollRowRef.current.offsetWidth / (columns === '3' ? 4 : 3)
      scrollRowRef.current.scrollLeft += direction * scrollAmount
    }
  }

  const propCardId = global_data.content?.cardsProperties?.type_id ?? '1'
  const CardProperty = require(`@components/cardsProperties/${propCardId}`)?.default

  const devCardId = global_data.content?.cardsDevelopments?.type_id ?? '1'
  const CardDevelopment = require(`@components/cardsDevelopments/${devCardId}`)?.default

  const [developments, setDevelopments] = useState<any>(allDevelopmentsData)

  useEffect(() => {
    if (allDevelopmentsData) {
      const devs = excludeIncludeDevelopments(allDevelopmentsData, includeTag!, excludeTag!)
      setDevelopments(devs)
    }
  }, [allDevelopmentsData])

  const noDevelopments =
    isDevelopment &&
    !isLoadingDevs &&
    // (!allDevelopmentsData?.length || allDevelopmentsData === undefined) &&
    (!getFeatured(developments)?.length || getFeatured(developments) === undefined)

  return (
    isMounted && (
      <section
        className={`p-y-config ${noFeaturedProperties || noDevelopments ? ' d-none' : ''}`}
        style={backgroundColor ? { backgroundColor: backgroundColor } : {}}
        id="featured-props"
      >
        <Container
          fluid
          className="featured-props c"
        >
          <Row className="mb-4 d-flex justify-content-between align-items-center">
            <Col>
              <ElementHTML
                children={title || 'Propiedades destacadas'}
                elementType={titleElement || 'h2'}
                style={titleColor ? { color: titleColor } : {}}
              />
            </Col>
            <Col className="arrow-container justify-content-end align-items-center d-none d-lg-flex">
              <i
                className="icon-arrow-stick-light arrow-left"
                onClick={() => handleScroll(-1)}
              />
              <i
                className="icon-arrow-stick-light arrow-right ms-4"
                onClick={() => handleScroll(1)}
              />
            </Col>
          </Row>
          <Row
            className="scrollable-row mb-5"
            ref={scrollRowRef}
          >
            {isLoadingProperties || isLoadingDevs
              ? Array.from({ length: columns === '3' ? 4 : 3 }).map((_, index) => (
                  <Col
                    xs={12}
                    lg={columns ? Number(columns) : 4}
                    key={index}
                  >
                    <CardProperty
                      {...props}
                      skeleton={true}
                    />
                  </Col>
                ))
              : isDevelopment
              ? developments &&
                getFeatured(developments)?.map(
                  (dev: Development | DevelopmentMediacore, index: number) => (
                    <Col
                      xs={12}
                      lg={columns ? Number(columns) : 4}
                      className="scrollable-col"
                      key={index}
                    >
                      <CardDevelopment
                        development={dev}
                        i={index}
                        isItem={true}
                        global_data={global_data}
                      />
                    </Col>
                  ),
                )
              : featuredPropertiesData?.objects?.map((prop: Property, index: number) => (
                  <Col
                    xs={12}
                    lg={columns ? Number(columns) : 4}
                    className="scrollable-col"
                    key={index}
                  >
                    <CardProperty
                      {...props}
                      key={index}
                      basic={true}
                      property={prop}
                      global_data={global_data}
                    />
                  </Col>
                ))}
          </Row>
          <Row className="justify-content-center">
            <Link
              className={'btn btn-primary border w-auto'}
              to={button?.link ?? '/'}
            >
              {button?.value ?? 'VER TODAS LAS PROPIEDADES'}
              <i className={`icon-arrow-stick ms-4 ${iconsStyle}`}></i>
            </Link>
          </Row>
        </Container>
      </section>
    )
  )
}

export default Summary_Props_3
